import type { Palette } from "@/components/ui/theme-provider";

export interface PaletteInfo {
  id: Palette;
  name: string;
  accent: string;
  gradientFrom: string;
  gradientTo: string;
}

export const palettes: PaletteInfo[] = [
  {
    id: "neon-pop",
    name: "Neon Pop",
    accent: "#EC4899",
    gradientFrom: "#EC4899",
    gradientTo: "#8B5CF6",
  },
  {
    id: "tropical-sunset",
    name: "Tropical Sunset",
    accent: "#FF6B6B",
    gradientFrom: "#FF6B6B",
    gradientTo: "#FF8E53",
  },
  {
    id: "aurora-borealis",
    name: "Aurora Borealis",
    accent: "#8B5CF6",
    gradientFrom: "#6366F1",
    gradientTo: "#06B6D4",
  },
  {
    id: "fresh-garden",
    name: "Fresh Garden",
    accent: "#10B981",
    gradientFrom: "#10B981",
    gradientTo: "#34D399",
  },
];

export function getPaletteById(id: Palette): PaletteInfo {
  return palettes.find((p) => p.id === id) ?? palettes[0];
}
